import { useDataChange } from 'Simple/Data.js'

export function useOnTimeout(props) {
  let change = useDataChange({
    context: 'new_address',
    viewPath: props.viewPath,
    path: 'type',
  })
  return function onClick() {
    change('form_submit')
  }
}
